/* Daywell theme JS */
(function () {
  'use strict';
  var T = window.theme || { routes: { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', root: '/' }, strings: {}, cartType: 'drawer' };
  var root = (T.routes.root || '/').replace(/\/?$/, '/');
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------- toast ---------- */
  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }

  /* ---------- drawers ---------- */
  var lastFocus;
  function openDrawer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open'); el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var f = el.querySelector('button, a, input'); if (f) setTimeout(function () { f.focus(); }, 50);
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open'); el.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open')) document.body.classList.remove('no-scroll');
    $$('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); openDrawer(document.getElementById(o.getAttribute('data-open'))); return; }
    var c = e.target.closest('[data-close]');
    if (c) { e.preventDefault(); closeDrawer(c.closest('.drawer')); return; }
    var co = e.target.closest('[data-cart-open]');
    if (co && T.cartType === 'drawer' && $('#CartDrawer') && !document.body.classList.contains('t-cart')) { e.preventDefault(); openDrawer($('#CartDrawer')); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { var d = $('.drawer.is-open'); if (d) closeDrawer(d); } });

  /* ---------- header ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 4); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }
  var st = $('[data-search-toggle]'), sb = $('[data-search-bar]');
  if (st && sb) st.addEventListener('click', function () {
    var open = sb.classList.toggle('is-open'); st.setAttribute('aria-expanded', open);
    if (open) { var i = sb.querySelector('input[type=search]'); if (i) i.focus(); }
  });

  /* ---------- cart ---------- */
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !(n > 0); });
  }
  function renderSections(sections) {
    if (sections && sections['cart-drawer']) {
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = doc.querySelector('#CartDrawer'), cur = $('#CartDrawer');
      if (fresh && cur) {
        var wasOpen = cur.classList.contains('is-open');
        cur.innerHTML = fresh.innerHTML;
        if (wasOpen) { cur.classList.add('is-open'); cur.setAttribute('aria-hidden', 'false'); }
      }
      var cnt = doc.querySelector('[data-cart-count-src]');
      if (cnt) setCount(parseInt(cnt.textContent, 10) || 0);
    }
  }
  function addToCart(formData, btn) {
    if (btn) btn.classList.add('is-loading');
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: formData })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
      .then(function (j) {
        if (T.cartType !== 'drawer') { window.location.href = T.routes.cart; return j; }
        renderSections(j.sections);
        openDrawer($('#CartDrawer'));
        return j;
      })
      .catch(function (err) { toast((err && (err.description || err.message)) || T.strings.error); throw err; })
      .finally(function () { if (btn) btn.classList.remove('is-loading'); });
  }
  function changeLine(line, qty) {
    var body = JSON.stringify({ line: line, quantity: qty, sections: ['cart-drawer'], sections_url: window.location.pathname });
    return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: body })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw j; return j; }); })
      .then(function (j) {
        if (document.body.classList.contains('t-cart')) { window.location.reload(); return; }
        renderSections(j.sections);
      })
      .catch(function (err) { toast((err && err.description) || T.strings.error); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line-qty]');
    if (!b) return;
    e.preventDefault();
    var item = b.closest('[data-line]');
    item.style.opacity = '.5';
    changeLine(parseInt(item.getAttribute('data-line'), 10), parseInt(b.getAttribute('data-line-qty'), 10));
  });
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-line-input]')) return;
    var item = e.target.closest('[data-line]'); item.style.opacity = '.5';
    changeLine(parseInt(item.getAttribute('data-line'), 10), Math.max(0, parseInt(e.target.value, 10) || 0));
  });
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches('[data-quick-add]')) {
      e.preventDefault();
      var btn = f.querySelector('button');
      addToCart(new FormData(f), btn).then(function () { if (btn) { btn.classList.add('is-done'); setTimeout(function () { btn.classList.remove('is-done'); }, 1500); } }).catch(function () {});
    } else if (f.matches('[data-product-form]')) {
      e.preventDefault();
      var add = f.querySelector('[data-add]');
      if (add && add.disabled) return;
      addToCart(new FormData(f), add).catch(function () {});
    }
  });

  /* ---------- product page ---------- */
  $$('[data-product]').forEach(function (pdp) {
    var jsonEl = pdp.parentNode.parentNode.querySelector('[data-product-json]') || $('[data-product-json]');
    var data = { variants: [] };
    try { data = JSON.parse(jsonEl.textContent); } catch (err) {}
    var form = pdp.querySelector('[data-product-form]');
    var idInput = pdp.querySelector('[data-variant-id]');
    var addBtn = pdp.querySelector('[data-add]');
    var priceWrap = pdp.querySelector('[data-price-wrap]');
    var skuEl = pdp.querySelector('[data-sku]');
    var main = pdp.querySelector('[data-gallery-main]');
    var thumbs = $$('[data-thumb]', pdp);
    var sticky = $('[data-sticky-buy]'), stickyAdd = $('[data-sticky-add]'), stickyPrice = $('[data-sticky-price]');

    function goTo(i) {
      if (!main) return;
      var slide = main.children[i]; if (!slide) return;
      main.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-thumb'), 10)); }); });
    if (main) {
      var raf;
      main.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(main.scrollLeft / main.clientWidth);
          thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
          var at = thumbs[i]; if (at && at.scrollIntoView && thumbs.length > 4) at.parentNode.scrollTo({ left: at.offsetLeft - 20, behavior: 'smooth' });
        });
      }, { passive: true });
    }

    $$('[data-qty]', pdp).forEach(function (b) {
      b.addEventListener('click', function () {
        var input = b.parentNode.querySelector('input');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10));
      });
    });

    function selected() { return $$('.opt', pdp).map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; }); }
    function findVariant(opts) {
      return data.variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0];
    }
    function markAvailability(opts) {
      $$('.opt', pdp).forEach(function (fs, idx) {
        $$('input', fs).forEach(function (inp) {
          var test = opts.slice(); test[idx] = inp.value;
          var ok = data.variants.some(function (v) { return v.available && v.options.every(function (o, i) { return o === test[i]; }); });
          var lab = fs.querySelector('label[for="' + inp.id + '"]'); if (lab) lab.classList.toggle('is-soldout', !ok);
        });
      });
    }
    function update() {
      var opts = selected();
      $$('[data-opt-label]', pdp).forEach(function (l, i) { l.textContent = opts[i] || ''; });
      var v = findVariant(opts);
      markAvailability(opts);
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = T.strings.unavailable; }
        if (stickyAdd) stickyAdd.disabled = true;
        return;
      }
      idInput.value = v.id;
      if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? T.strings.add : T.strings.soldOut; }
      if (stickyAdd) stickyAdd.disabled = !v.available;
      if (priceWrap) {
        var html = '<div class="price"><span class="price__now' + (v.compare ? ' is-sale' : '') + '">' + v.price + '</span>';
        if (v.compare) html += '<span class="price__was">' + (T.strings.was || 'Was') + ' <s>' + v.compare + '</s></span><span class="price__save">' + (T.strings.save || 'Save') + ' ' + v.save + '</span>';
        priceWrap.innerHTML = html + '</div>';
      }
      if (stickyPrice) stickyPrice.textContent = v.price.replace(/<[^>]+>/g, '');
      if (skuEl) skuEl.textContent = v.sku ? ('SKU: ' + v.sku) : '';
      if (v.media && main) {
        var slides = Array.prototype.slice.call(main.children);
        for (var i = 0; i < slides.length; i++) { if (slides[i].getAttribute('data-media-id') == v.media) { goTo(i); break; } }
      }
      if (window.history && history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
      }
    }
    $$('.opt input', pdp).forEach(function (i) { i.addEventListener('change', update); });
    if ($$('.opt', pdp).length) markAvailability(selected());

    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var show = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      }).observe(addBtn);
      stickyAdd.addEventListener('click', function () {
        if (form.querySelector('.opt') && !findVariant(selected())) { addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        addToCart(new FormData(form), stickyAdd).catch(function () {});
      });
    }
  });

  /* ---------- related products ---------- */
  $$('[data-recs]').forEach(function (el) {
    var url = el.getAttribute('data-url'); if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (t) {
      var d = new DOMParser().parseFromString(t, 'text/html');
      var s = d.querySelector('[data-recs]');
      if (s && s.innerHTML.trim()) el.innerHTML = s.innerHTML;
    }).catch(function () {});
  });

  /* ---------- collection / search: sort & filters ---------- */
  $$('[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () {
      var url = new URL(window.location.href); url.searchParams.set('sort_by', s.value); url.searchParams.delete('page'); window.location.href = url.toString();
    });
  });
  $$('[data-filter-form]').forEach(function (f) {
    var t;
    function go() {
      var p = new URLSearchParams(new FormData(f));
      var cur = new URL(window.location.href);
      if (cur.searchParams.get('sort_by') && !p.get('sort_by')) p.set('sort_by', cur.searchParams.get('sort_by'));
      Array.from(p.keys()).forEach(function (k) { if (p.get(k) === '') p.delete(k); });
      window.location.href = window.location.pathname + '?' + p.toString();
    }
    f.addEventListener('change', function (e) { clearTimeout(t); t = setTimeout(go, e.target.type === 'number' ? 700 : 150); });
    f.addEventListener('submit', function (e) { e.preventDefault(); go(); });
  });
  $$('[data-filters-toggle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var p = $('[data-filters]'); if (!p) return;
      var open = p.classList.toggle('is-open'); b.setAttribute('aria-expanded', open);
    });
  });

})();
